module.exports = __webpack_public_path__ + "img/24.094a6fd9.jpg";